<ng-container *ngFor="let row of data.rows">
  <div [class]="row.class || 'row'">
    <ng-container *ngFor="let field of row.fields">
      <div [class]="field.class || 'col-md-4'">
        <!-- <app-input
          *ngIf="
            field.inputType === inputTypes.INPUT || field.inputType == null
          "
          [form]="data.form"
          [controlName]="field.controlName"
          [type]="field.type"
          [error]="field.error"
          [label]="field.label"
        ></app-input>
        <app-select
          *ngIf="field.inputType === inputTypes.SELECT"
          [controlName]="field.controlName"
          [options]="field.option"
          [valueKey]="field.valueKey"
          [displayKey]="field.displayKey"
          [error]="field.error"
          [label]="field.label"
          [form]="data.form"
        ></app-select>
        <app-textarea
          *ngIf="field.inputType === inputTypes.TEXTAREA"
          [controlName]="field.controlName"
          [error]="field.error"
          [label]="field.label"
          [form]="data.form"
        ></app-textarea> -->
      </div>
    </ng-container>
  </div>
</ng-container>
